// extracted by mini-css-extract-plugin
export default {"widgetList":"RolesWidget_widgetList__NTG9D","widgetListItem":"RolesWidget_widgetListItem__VyCEA"};